import React from 'react';
import { Moment } from "moment";
import { useDispatch } from "react-redux";
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { updateMovement } from '@features/whereabouts/store/editMovements.duck';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { MovementImage } from "../../../atoms/MovementImage";
import { iconPackPath } from '@shared/utils/WhereaboutsHelper';
import { BodyRegular, BodyVerySmall } from "../../../atoms/fonts/Body";
import Colours from "../../../atoms/Colours";
import { AddNoteButton } from "./AddNoteButton";
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import { addNewNote } from '@features/whereabouts/store/dayNotes.duck';
import styled from "styled-components";
import { Pill } from "../../../atoms/Pill";
import { desktop1100 } from "../../../atoms/MediaQueries";
import { RecentNotes } from "./RecentNotes";

export function DayNotesActivityItem(props: Props) {
  const {activeDay, iconPack, activity, activeUserId} = props;
  const dispatch = useDispatch();

  const updateSelectedDay = (e: any) => {
    e.stopPropagation();
    dispatch(openDialogWithPayload({
      payload: { onSaveClicked: onNoteEnteredOrSelected, whereabouts: activity, },
      activeDialog: DialogIdentifiers.DayNotesEntryDialog
    }))
  }

  const onNoteEnteredOrSelected = (e: Event, note: string) => {
    dispatch(updateMovement({selectedOption: activity, locationId: 0, activeDay: activeDay?.format(DATE_FORMAT), activeUserId, dayNote: note}));
    dispatch(addNewNote({noteToAdd: note, optionId: activity.id}));
  }

  const activitySelected = (e: any) => {
    e.stopPropagation();
    dispatch(updateMovement({selectedOption: activity, locationId: 0, activeDay: activeDay?.format(DATE_FORMAT), activeUserId}));
  }

  return (<Container className="activity" onClick={(e: any) => activitySelected(e)}>
    <Left>
      <ActivityTitleSection>
        <MovementImage src={iconPackPath(iconPack, activity.image, FreeBusyStatus.FREE)} alt={activity.alt}/>
        <BodyRegular weight={600}>{activity.label}</BodyRegular>
      </ActivityTitleSection>
      {props?.activity?.isPrivate && <BodyVerySmall colour={Colours.mildGrey} title={'This is only visible to you, line managers, and company admins.'}>Private</BodyVerySmall>}
      <DayNotesListContainer>
        <RecentNotes whereaboutsOptionId={activity.id} onNoteSelected={onNoteEnteredOrSelected} />
      </DayNotesListContainer>
    </Left>
    <AddNoteButton onClick={(e: any) => updateSelectedDay(e)} />
  </Container>)
}

interface Props {
  activeDay?: Moment;
  iconPack: any;
  activity: any;
  activeUserId?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;

  @media (${desktop1100}) {
    width: 80%;
  }
`

const ActivityTitleSection = styled.div`
  display: flex;
  align-items: center;
`

export const DayNotesListContainer = styled.div`
  max-height: 36px;
  display: flex;
  width: 100%;
  margin-top: 4px;
  button {
    width: 100px;
  }
`

export const RecentNotesContainer = styled.div`
  display: flex;
  overflow: hidden;
`

export const DayNotePill = styled(Pill)<any>`
  cursor: pointer;
  margin-right: 8px;
  max-width: 200px;
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  &:hover {
    background-color: ${Colours.blue10};
  }
`
